import React, { useEffect, useState } from "react";
import Constants from "../../utils/constants";
import moment from "moment";
import "./styles.scss";
import { langStringConvertor } from "../../utils/utils";

const { LANGUAGES } = Constants;
const { minute, scheduled, noScheduled } = LANGUAGES;

const FirstStationTitle = (props) => {
  const { time, timestamp, remarks } = props;

  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(props.language);
  }, [props.language]);

  const renderTime = (time, timestamp) => {
    if (typeof time === "number") {
      if (time >= 90) {
        return (
          <>
            <span className={`time ${!remarks ? "eta" : ""}`}>
              {timestamp ? moment(timestamp).format("HH:mm") : `-`}
            </span>
            {/* <span className="minute">{minute[language]}</span> */}
          </>
        );
      } else {
        return (
          <>
            <span className={`time ${!remarks ? "eta" : ""}`}>
              {time >= 0 && time < 90 ? time : "-"}
            </span>
            <span className="minute">{minute[language]}</span>
          </>
        );
      }
    } else {
      return (
        <>
          <span className="time">-</span>
          <span className="minute">{minute[language]}</span>
        </>
      );
    }
  };

  const renderSchedule = (timestamp) => {
    return (
      <span className="time smaller-text">
        {timestamp ? moment(timestamp).format("HH:mm") : `-`}
      </span>
    );
  };

  return (
    <div className="station-title-container">
      {timestamp ? (
        <>
          <div className="dot-container">
            <div className="station">
              <div>
                <div className="station">{renderTime(time, timestamp)}</div>
              </div>
            </div>
          </div>
          <div>
            <div className="station schedule">
              <span className="schedule-text">{scheduled[language]}</span>
              {renderSchedule(timestamp)}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="dot-container">
            <div className="station">
              <div>
                <div className="station"></div>
              </div>
            </div>
          </div>
          <div>
            <div className="station schedule">
              <span className="schedule-text"></span>
              <span className="time smaller-text">{noScheduled[language]}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FirstStationTitle;
